/**
 * Money-Helpers für die Score-Engine — Schutz gegen Float-Drift.
 *
 * Geld wird in `MoneyCents` (Integer-Cents, siehe `schema/brands.ts`) geführt.
 * Aggregationen wie Mittelwerte über mehrere Monate liefern aber mathematisch
 * Floats wie `1234567.333…`. Damit das Branding-Versprechen „MoneyCents ist
 * immer Integer" beim Weiterreichen erhalten bleibt, runden wir am Ende.
 */
import type { MoneyCents } from '../../schema/brands.js';

/**
 * Mittelwert über eine Liste von Cent-Beträgen, gerundet auf Integer-Cents.
 *
 * Liefert 0 für eine leere Liste — Aufrufer entscheiden selbst, ob das
 * fachlich korrekt ist (in der Score-Engine wird der Mittelwert nur
 * berechnet, wenn `monthlyAggregates.length >= 1`, das Schema garantiert
 * mindestens einen Eintrag).
 */
export function avgCents(values: readonly MoneyCents[]): MoneyCents {
  if (values.length === 0) return 0 as MoneyCents;
  let sum = 0;
  for (const v of values) sum += v as number;
  return Math.round(sum / values.length) as MoneyCents;
}
